<template>
  <div style="position:relative;">
    <div class="l-label"></div>

    <Upload
      multiple
      v-if="editable"
      type="drag"
      :class="html?'not-empty-wrap':''"
      accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      :show-upload-list="false"
      :before-upload="onUploadFile"
      :action="''"
    >
      <div style="margin:20px 0;" :class="url?'not-empty':''">
        <BaseIcon v-if="!url" icon="ios-cloud-upload" size="52" style="color: var(--primary)"  />
        <BaseIcon v-else icon="wancheng" size="52" style="color: var(--success)"  />
        <p style="font-size:25px;margin-top:10px;" :style="`color:${url?'var(--success)':'var(--primary)'}`">{{url ? '上传完毕':'述职报告'}}</p>
        <p style="margin-top:5px;">{{url?'重新上传文档':'点击或拖拽文件到此处上传'}}</p>

      </div>
    </Upload>
    <div v-else class="flex-wrap flex-center" style="width:100%;border:1px solid var(--border)">
      <div style="margin:20px 0;text-align:center;" :class="url?'not-empty':''">
        <BaseIcon v-if="!url" icon="ios-cloud-upload" size="52" style="color: var(--primary)"  />
        <BaseIcon v-else icon="wancheng" size="52" style="color: var(--success)"  />
        <p style="font-size:25px;margin-top:10px;" :style="`color:${url?'var(--success)':'var(--primary)'}`">{{url ? '上传完毕':'述职报告'}}</p>
        <a @click="onDownload(url)" v-if="url">下载文件</a>
      </div>
    </div>
    <a
      style="position:absolute;right:10px;top:10px;color:var(--subtext2);"
      v-if="state"
      @click="onDownload(url)"
    >{{state}}</a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      html: '',
      url: null,
      state: '',
    };
  },
  watch: {
    //   value:{
    //     handler(v){
    //       if(v){
    //         this.html = v.html
    //         this.url = v.url
    //       }
    //     },
    //     immediate:true,
    //     deep:true
    //   }
    url: {
      handler(v) {
        this.$emit('change', {html: this.html, url: this.url});
      },
      immediate: true,
    },
  },
  props: {
    index: {
      type: [Number, String],
    },
    label: {
      type: String,
    },
    value: {
      type: Object | String,
      default: () => ({}),
    },
    editable: {
      type: Boolean,
    },
    error: {
      type: String,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    if (this.value) {
      this.html = this.value.html;
      this.url = this.value.url;
      this.state = '下载文件';
    }
  },
  methods: {
    onDownload(url) {
      if (!url) return;
      const a = document.createElement('a');
      a.href = url;
      a.download = 'download';

      document.body.appendChild(a);

      a.click();
      a.remove();
    },
    onUpdateProgress(e) {
      this.state = `上传中(${e.percent})`;
    },
    onUploadFile(e) {
      const that = this;

      that.state = '上传中';
      that.$cos.upload([e], {onProgress: this.onUpdateProgress, onFail: ()=>{
        this.Error('上传错误,请联系管理员');
        this.html = '';
        this.state = '错误';
      }, onSuccessFile: (file)=>{
        that.state = '下载文件';
        that.url = file.url;
        that.Success({title: '上传成功'});

        that.$emit('input', {url: that.url, html: ''});
      }},
      {coskey: this.$store.getters['session/session'].coskey});

      return false;
    },
    onSuccess(e) {

    },
  },
};
</script>

<style less>
.htable {
  border: 1px solid #ddd;
}
.not-empty-wrap {
  width: 200px;
  margin: 0 auto !important;
  margin-bottom: 10px !important;
}
.not-empty {
  padding: 5px 0 !important;
  color: #aaa;
}
</style>
